export const imageBreakpoints: Record<number, number | number[]> = {
	1920: 300,
	1680: 300,
	1600: 300,
	1536: 300,
	1440: 300,
	1366: 300,
	1280: 300,
	428: [200, 300, 400],
	414: [200, 300, 400],
	412: [200, 300, 400],
	393: [200, 300, 400],
	390: [200, 300, 400],
	385: [200, 300, 400],
	384: [200, 300, 400],
	375: [200, 300, 400],
	360: [200, 300, 400],
	320: [200, 300, 400],
};
